<template>
    <div class="breadcrumb" v-if="currentView !== 'home'">
        <ul class="breadcrumb__ul">
            <li class="breadcrumb__li">
                <router-link class="breadcrumb__link" to="/">All RCDC Categories
                    <i class="svg fa fa-chevron-right fa-lg"/>
                </router-link>
            </li>
            <li class="breadcrumb__li">
                <router-link class="breadcrumb__link" :to="'/rcdc?rcdcCategory=' + selectedRcdc" v-if="!icViewFromHome">{{filters.categoryNameFilter(selectedRcdc)}}
                    <i class="svg fa fa-chevron-right fa-lg"/>
                </router-link>
                <a v-else class="breadcrumb__link disabled" href="" @click.prevent="">{{filters.categoryNameFilter(selectedRcdc)}}
                    <i class="svg fa fa-chevron-right fa-lg"/>
                </a>
            </li>
            <li class="breadcrumb__li" v-if="currentView == 'ic'">
                <a class="breadcrumb__link" href="" @click.prevent="">{{selectedIc}}
                    <i class="svg fa fa-chevron-right fa-lg"/>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import globalMixins from '@/js/globalMixins';

export default {
    name: 'Breadcrumb',
    mixins: [globalMixins],
    computed: {
        ...mapGetters([
            'selectedRcdc',
            'selectedIc',
            'icViewFromHome'
        ])
    },
    data () {
        return {
            filters: window.filters 
        }
    }
};
</script>

<style lang="scss">
.breadcrumb {
    padding: 5px $home-page-padding;
    background: #fff;
}

.breadcrumb__ul {
    padding: 0;
    margin: 0;
    display: inline-block;
}

.breadcrumb__li {
    list-style: none;
    float: left;
    margin-right: 5px;
}

.breadcrumb__link {
    color: #555;
    font-weight: bold;
    transition: 0.5;

    &:hover,
    &:active {
        text-decoration: none;
        color: lighten( #555, 10% );

        .svg {
            color: lighten( #555, 30% );;
        }
    }

    .svg {
        color: lighten( #555, 40% );
    }
}
</style>


